// Route path builders.
//
// react-router resolves relative navigation against the matched *route*, while
// react-router v5 resolved it against the current URL. A './foo' that used to
// replace the last URL segment now gets appended instead, so anything that was
// URL-relative builds an absolute path from its params here.

export const creditAccountPath = (customerId, accountId, view) => {
  const accountPath = `/customers/${customerId}/accounts/credit/${accountId}`;
  return view ? `${accountPath}/${view}` : accountPath;
};
